import { load, validate } from '@scalar/openapi-parser'
import { fetchUrls } from '@scalar/openapi-parser/plugins/fetch-urls'
import { readFiles } from '@scalar/openapi-parser/plugins/read-files'

import { Command } from 'commander'
import as from 'ansis'
import prettyjson from 'prettyjson'

import { output } from '@/helpers/std-out'

/**
 * Validate an OpenAPI file against the OpenAPI specifications
 */
export function ValidateCommand() {
  const cmd = new Command('validate')

  cmd.description('Validate an OpenAPI file')
  cmd.argument('[file|url]', 'File or URL to validate')
  cmd.action(async (inputArgument: string) => {
    const startTime = performance.now()

    if (!inputArgument) {
      return output
        .error()
        .title('Invalid argument')
        .message('Please provide a file path')
        .exit('error')
    }

    // Validate
    const { filesystem } = await load(inputArgument, {
      plugins: [fetchUrls(), readFiles()],
    })

    const result = await validate(filesystem)

    if (result.valid && result.version) {
      const endTime = performance.now()
      output
        .info()
        .line(
          as.green(
            `Matches the OpenAPI specification${as.white(` (OpenAPI ${as.bold(result.version)})`)}\n`,
          ),
        )
        .line(
          `${as.green('File validated')} ${as.grey(
            `in ${as.white(`${as.bold(`${Math.round(endTime - startTime)}`)} ms`)}\n`,
          )}`,
        )
        .print()
    } else {
      output
        .error()
        .message(prettyjson.render(result.errors))
        .message(
          as.red(
            `File does not match the OpenAPI ${result.version ? `${result.version} ` : ''}specification.`,
          ),
        )
        .message(
          as.red(
            `${as.bold(
              `${result.errors?.length} error${result.errors && result.errors.length > 1 ? 's' : ''}`,
            )} found.`,
          ),
        )
        .exit('error')
    }
  })

  return cmd
}
